import { render, staticRenderFns } from "./ReceiveSampleCollate.vue?vue&type=template&id=d2725f96&scoped=true&"
import script from "./ReceiveSampleCollate.vue?vue&type=script&lang=js&"
export * from "./ReceiveSampleCollate.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveSampleCollate.vue?vue&type=style&index=0&id=d2725f96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2725f96",
  null
  
)

export default component.exports